export default [
    ['PC', 'PC端'],
    ['MOBILE', '移动端'],
]
